module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "everynew",
    attrs: {
      "id": "news"
    }
  }, [_c('div', {
    staticClass: "new_pic"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'article-detail',
        params: {
          id: _vm.id
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.front_img_path,
      "alt": "front"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9be048a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 1063
// module chunks = 40